var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourier5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9206 0C35.5797 0 45.8412 10.2616 45.8412 22.9206C45.8412 35.5797 35.5797 45.8412 22.9206 45.8412C10.2616 45.8412 0 35.5797 0 22.9206C0 10.2616 10.2616 0 22.9206 0ZM22.9206 9.16825C22.3127 9.16825 21.7297 9.40973 21.2999 9.83957C20.87 10.2694 20.6286 10.8524 20.6286 11.4603V22.9206C20.6287 23.5285 20.8703 24.1114 21.3001 24.5411L28.1763 31.4173C28.6086 31.8348 29.1876 32.0658 29.7885 32.0606C30.3895 32.0554 30.9644 31.8143 31.3894 31.3894C31.8143 30.9644 32.0554 30.3895 32.0606 29.7885C32.0658 29.1876 31.8348 28.6086 31.4173 28.1763L25.2127 21.9717V11.4603C25.2127 10.8524 24.9712 10.2694 24.5413 9.83957C24.1115 9.40973 23.5285 9.16825 22.9206 9.16825Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier5);
export default __webpack_public_path__ + "static/media/courier5.5622bff7a11b927a9e476368c7be2a0f.svg";
export { ForwardRef as ReactComponent };